import { CENTRAL_HUB_BASE_URL } from 'src/environments/base-url';

export const getLanguagesUrl = (): string => `${CENTRAL_HUB_BASE_URL}/languages`;
